var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (curatorItems, editorialItems, exploreItems, fair, primaryItems, profile, undefined) {
buf.push("<div class=\"fair-page-footer\"><div class=\"fair-footer-left\"><div class=\"footer-section-heading\">Explore the Fair</div><div class=\"footer-square-sections\"><a" + (jade.attr("href", profile.href() + "/browse", true, true)) + " class=\"footer-square-section\"><img" + (jade.attr("src", fair.imageUrl('large_rectangle'), true, true)) + "><div class=\"fair-footer-heading\">All Exhibitors</div></a>");
if ( exploreItems)
{
// iterate exploreItems
;(function(){
  var $$obj = exploreItems;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"footer-square-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><div class=\"fair-footer-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</div></a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"footer-square-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><div class=\"fair-footer-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</div></a>");
    }

  }
}).call(this);

}
if ( primaryItems)
{
// iterate primaryItems
;(function(){
  var $$obj = primaryItems;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"footer-square-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><div class=\"fair-footer-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</div></a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"footer-square-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><div class=\"fair-footer-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</div></a>");
    }

  }
}).call(this);

}
buf.push("</div><a" + (jade.attr("href", profile.href() + "/browse/artworks", true, true)) + " class=\"avant-garde-header-center\">Browse all works</a></div><div class=\"fair-footer-right\">");
if ( editorialItems)
{
buf.push("<div class=\"footer-section-heading\">Read Highlights from the Fair</div><div class=\"fair-footer-posts-container\">");
// iterate editorialItems.slice(0, 2)
;(function(){
  var $$obj = editorialItems.slice(0, 2);
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-post\"><img" + (jade.attr("src", item.imageUrl('small_rectangle'), true, true)) + "><div class=\"post-text\"><div class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</div>");
if ( item.get('subtitle'))
{
buf.push("<div class=\"section-subheading\">" + (jade.escape(null == (jade_interp = item.get('subtitle')) ? "" : jade_interp)) + "</div>");
}
buf.push("</div></a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-post\"><img" + (jade.attr("src", item.imageUrl('small_rectangle'), true, true)) + "><div class=\"post-text\"><div class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</div>");
if ( item.get('subtitle'))
{
buf.push("<div class=\"section-subheading\">" + (jade.escape(null == (jade_interp = item.get('subtitle')) ? "" : jade_interp)) + "</div>");
}
buf.push("</div></a>");
    }

  }
}).call(this);

buf.push("</div>");
}
if ( curatorItems)
{
buf.push("<div class=\"fair-footer-curator\"><div class=\"footer-section-heading-small\">Art world insiders share their selections</div><div class=\"curator-picks-container\">");
// iterate curatorItems.slice(0, 3)
;(function(){
  var $$obj = curatorItems.slice(0, 3);
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-section\"><img" + (jade.attr("src", item.imageUrl('small_square'), true, true)) + "><div class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</div>");
if ( item.get('subtitle'))
{
buf.push("<div class=\"section-subheading\">" + (jade.escape(null == (jade_interp = item.get('subtitle')) ? "" : jade_interp)) + "</div>");
}
buf.push("</a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-section\"><img" + (jade.attr("src", item.imageUrl('small_square'), true, true)) + "><div class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</div>");
if ( item.get('subtitle'))
{
buf.push("<div class=\"section-subheading\">" + (jade.escape(null == (jade_interp = item.get('subtitle')) ? "" : jade_interp)) + "</div>");
}
buf.push("</a>");
    }

  }
}).call(this);

buf.push("</div></div>");
}
buf.push("<a" + (jade.attr("href", profile.href() + "/posts", true, true)) + " class=\"avant-garde-header-center\">See All Highlights</a></div></div>");}.call(this,"curatorItems" in locals_for_with?locals_for_with.curatorItems:typeof curatorItems!=="undefined"?curatorItems:undefined,"editorialItems" in locals_for_with?locals_for_with.editorialItems:typeof editorialItems!=="undefined"?editorialItems:undefined,"exploreItems" in locals_for_with?locals_for_with.exploreItems:typeof exploreItems!=="undefined"?exploreItems:undefined,"fair" in locals_for_with?locals_for_with.fair:typeof fair!=="undefined"?fair:undefined,"primaryItems" in locals_for_with?locals_for_with.primaryItems:typeof primaryItems!=="undefined"?primaryItems:undefined,"profile" in locals_for_with?locals_for_with.profile:typeof profile!=="undefined"?profile:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;